import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ArtStage from '../../../ArtStage';
import Details from '../../../DeviationViews/Details';
import TextualContent from '../../../DeviationViews/TextualContent/TextualContent';
import Sidebar from '../../../Sidebar';
import StashBanner from '../../../banners/StashBanner';
import ActionBar from '../../../ActionBar';
import { useIsCurrentUserDeviationAuthor } from '../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import CentralColumn from '../CentralColumn';
import Comments from '../Comments';
import s from './StashPageContent.scss';
const StashPageContent = ({ deviation })=>{
    const isMobile = useContext(MobileContext);
    const isAuthor = useIsCurrentUserDeviationAuthor(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['stage']
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), !isMobile && isAuthor && /*#__PURE__*/ React.createElement(StashBanner, {
        className: s['banner']
    }), /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(TextualContent, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(Details, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['meta']
    }, /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(Comments, {
        deviation: deviation,
        className: s['comments']
    }))), /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation,
        className: s['sidebar']
    }));
};
StashPageContent.displayName = 'StashPageContent';
export default StashPageContent;

//# sourceMappingURL=StashPageContent.js.map